import { render } from "./PaymentSection.vue?vue&type=template&id=2da28047"
import script from "./PaymentSection.vue?vue&type=script&lang=js"
export * from "./PaymentSection.vue?vue&type=script&lang=js"

import "./PaymentSection.vue?vue&type=style&index=0&id=2da28047&lang=css"
script.render = render

export default script